import { Components, Theme } from '@mui/material';
import { dateRangePickerDayClasses } from '@mui/x-date-pickers-pro';

/**
 * Component overrides (i.e. global styles, default props) applied to the MUI
 * MuiDateRangePickerDay to make it match the design system.
 *
 * See: https://mui.com/x/api/date-pickers/date-range-picker-day/#css
 */
const borderRadius = '4px';

const endBorderStyle = {
  borderTopRightRadius: borderRadius,
  borderBottomRightRadius: borderRadius,
};
const startBorderStyle = {
  borderTopLeftRadius: borderRadius,
  borderBottomLeftRadius: borderRadius,
};

export const MuiDateRangePickerDay: Components<Theme>['MuiDateRangePickerDay'] = {
  styleOverrides: {
    root: {
      borderRadius: 0,
      '&:first-of-type': {
        // highlight start of week
        ...startBorderStyle,

        // preview start of week
        [`.${dateRangePickerDayClasses.rangeIntervalDayPreview}`]: {
          ...startBorderStyle,
        },
      },
      '&:last-of-type': {
        // highlight end of week
        ...endBorderStyle,

        // preview end of week
        [`.${dateRangePickerDayClasses.rangeIntervalDayPreview}`]: {
          ...endBorderStyle,
        },
      },
      [`&.${dateRangePickerDayClasses.firstVisibleCell}`]: {
        ...startBorderStyle,
      },
      [`&.${dateRangePickerDayClasses.lastVisibleCell}`]: {
        ...endBorderStyle,
      },
    },

    day: ({ theme }) => ({
      borderRadius: 0,
      width: '36px',
      height: '24px',
      // today
      '&:not(.Mui-selected)': {
        borderRadius,
        borderColor: theme.palette.primary.main,
        // hover for non-active elements
        [`&.${dateRangePickerDayClasses.dayOutsideRangeInterval}:hover`]: {
          borderColor: 'transparent',
          backgroundColor: theme.palette.divider,
        },
      },
      // start-only range selection
      [`&.Mui-selected.${dateRangePickerDayClasses.dayOutsideRangeInterval}`]: {
        borderRadius,
        background: theme.palette.primary.main,
      },
    }),

    outsideCurrentMonth: {
      [`.${dateRangePickerDayClasses.rangeIntervalPreview}`]: {
        background: 'transparent',
      },
    },

    rangeIntervalDayPreviewStart: {
      ...startBorderStyle,
    },
    rangeIntervalDayPreviewEnd: {
      ...endBorderStyle,
    },

    rangeIntervalDayHighlightStart: ({ theme }) => ({
      [`.${dateRangePickerDayClasses.rangeIntervalPreview}`]: {
        background: theme.palette.primary.main,
        ...startBorderStyle,
      },
      [`.${dateRangePickerDayClasses.day}`]: {
        ...startBorderStyle,
      },
    }),
    rangeIntervalDayHighlightEnd: ({ theme }) => ({
      [`.${dateRangePickerDayClasses.rangeIntervalPreview}`]: {
        background: theme.palette.primary.main,
        ...endBorderStyle,
      },
      [`.${dateRangePickerDayClasses.day}`]: {
        ...endBorderStyle,
      },
    }),
  },
};
